import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NewServicePromo.css';

const NewServicePromo = ({ onClose }) => {
  const navigate = useNavigate();

  const handleExploreNow = () => {
    onClose();
    navigate('/rent');
    window.scrollTo(0, 0);
  };

  return (
    <div className="new-service-promo-overlay" role="dialog" aria-modal="true" aria-labelledby="new-service-promo-title">
      <div className="new-service-promo-dialog">
        <button
          type="button"
          className="new-service-promo-close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <span className="new-service-promo-badge">New Service</span>
        <h2 id="new-service-promo-title" className="new-service-promo-title">
          Website on Rent
        </h2>
        <p className="new-service-promo-text">
          Explore our newest offering — get a professional, ready-to-go website on rent.
          Launch fast without heavy upfront cost.
        </p>
        <div className="new-service-promo-actions">
          <button type="button" className="btn" onClick={handleExploreNow}>
            Explore Now
          </button>
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewServicePromo;
